import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useLayoutEffect,
} from "react";
// import { useHistory, useLocation } from "react-router-dom";
import moengage from "@moengage/web-sdk";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetCustomerDetailsContext,
  GetCustomerDetails,
  validateInputExistenece,
} from "../../App";
import { SEND_EMAIL_OTP, VERIFY_EMAIL_OTP } from "../../Config";
import Icon_Agreement_form from "../../assets/svg/EPL_think_svg/Icon_Agreement_form.svg";
import FloatingInput from "../../components/base/FloatingInput.js";
import Pdf_icon from "../../assets/svg/EPL_think_svg/Pdf_icon.svg";
import upload_icon from "../../assets/svg/EPL_think_svg/upload.svg";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import OTPInput from "../../components/base/OtpInput.js";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import CheckField from "../../components/form/CheckField";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidOTP } from "../../shared/validations/OTP";
import { encrypt } from "../../utils/crypto";
import LoanSummaryTextItem from "./_styles/EPL_LoanSummaryTextItem";
import Modal from "./_styles/EPL_Modal";
import Text from "./_styles/EPL_Text.js";
import sendRequest from "../../utils/sendRequest";
import { DisbursementReverifyWrapper } from "./_styles/LoanAgreementWrapper.js";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import {
  IncorrectOtpModal,
  MaxOtpRetryModal,
  OtpExpiredModal,
  ResendOtpEmailModal,
  CheckInternetModal,
  A8MovedModal,
} from "../other-pages/Modals/AllModal";
import styled from "styled-components";
import { updateLead } from "../../shared/services/crm";
import { UPLOAD_DOCS_NSTP, MOVE_TO_NSTP } from "../../Config";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import { encryptedData } from "../../utils/index.js";
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const DocumentUploadInputWrapper = styled.div`
  border: 2px solid #999999;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 0.5em 1em 0.5em 1em;
  .main-container-doc-input {
    display: flex;
    justify-content: space-between;
    margin: 1em 0 1.4em 0;
  }

  .main-container-doc-input div {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  span > label {
    margin-bottom: 0;
  }

  p {
    margin-bottom: 0;
    line-height: 90%;
  }

  span > p:first-child {
    font-size: 1.5em;
  }

  span > p:last-child {
    color: var(--gray);
  }

  span > img {
    height: 2em;
  }

  div + span {
    display: flex;
    align-items: center;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    padding-bottom: 1em;
  }

  form span {
    display: flex;
    justify-content: space-between;
  }

  filter: ${(props) => (props.disabled ? "opacity(50%)" : "none")};
`;

const DisbursementReverify = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [isOpen, setIsOpen] = useState(true);
  const [errorMessagefile1, setErrorMessageFile1] = useState("");
  const [errorMessagefile2, setErrorMessageFile2] = useState("");
  const [errorMessagefile3, setErrorMessageFile3] = useState("");

  const frontUploadRef = useRef();
  const backUploadRef = useRef();
  const otpWaitTime = "00:10";
  const [showEmailOTPModal, setShowEmailOTPModal] = useState();
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [enableResendOtp, SetEnableResendOtp] = useState(false);
  const [seconds, setSeconds] = useState();
  const [minutes, setMinutes] = useState();
  const [load, setLoad] = useState();
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [otp, setOtp] = useState("");
  const [modal, setModal] = useState("");
  const [resendOtpButtonDisabled, setResendOtpButtonDisabled] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);
  const [KFS, setKFS] = useState("");
  const [SanctionLetter, setSanctionLetter] = useState("");
  const [Agreement, setAgreement] = useState("");
  const [isIPhoneSafariUser, setIsIPhoneSafariUser] = useState(false);

  const [mobNum, setMobNum] = useState("");
  const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
  const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
  const [ischecked, setIsChecked] = useState(false);
  const [internetCheck, setInternetCheck] = useState(false);
  const [isOtpwrong, SetIsOtpWrong] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(false);
  const source = location.pathname.split("/")[1];

  const [selectedSection, setSelectedSection] = useState("Upload Salary slip");

  const resendOTP = async () => {
    var payload = {
      application_form_no: customerDetails?.application_form_number,
      // email: customerDetails?.Data?.org_email_id,
      email: customerDetails?.Data?.org_email_id,
      mode: "EMPLOYMENT_CHECK",
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + SEND_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        // console.log("Otp sent");
        setIsOtpSent(true);
        setShowShimmer(false);
        setResendOtp(true);
        SetEnableResendOtp(false);
        setMinutes(2);
        setSeconds(59);
        resetOTP();
      }
      if (response.response.ErrorType == "OTP_MAX_RETRY") {
        // console.log("Maximum retry reached");
        let min = parseInt(parseInt(response?.response.Data.retryTimer) / 60);
        let sec = parseInt(parseInt(response?.response.Data.retryTimer) % 60);
        setShowShimmer(false);
        setShowMaxRetryModal(true);
        setMinutes(min);
        setSeconds(sec + 2);
        SetEnableResendOtp(false);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });

        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  const VerifyOTPOnEmail = async () => {
    try {
      var payload = {
        application_form_no: customerDetails?.application_form_number,
        otp: otp,
        email: customerDetails?.Data?.org_email_id,
        mode: "EMPLOYMENT_CHECK",
      };
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + VERIFY_EMAIL_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        setShowShimmer(false);
        // console.log("Otp Verified");
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      }
      if (response.response.ErrorType == "INVALID_OTP") {
        setShowShimmer(false);
        // console.log("incorrect");
        SetIsOtpWrong(true);
      }
      if (response.response.ErrorType == "OTP_EXPIRED") {
        setShowShimmer(false);
        setShowOtpExpiredModal(true);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          64,
          customerDetails.application_form_number
        );
      }
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });

        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  useEffect(async () => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("LoanAgreement customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed
      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      // console.log("00 - stage: ", customerDetails.stage);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);

      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });

      // console.log("LoanAgreement Ouch customerDetails ", location);
    }
    // console.log("Called GetCustomerDetails --- agreement");
    if (
      customerDetails.stage === "DOCUMENT_SUBMITTED" ||
      customerDetails.stage === "READY_FOR_DISBURSEMENT"
    ) {
      seta8Modal(true);
    }
    // console.log(customerDetails);
  }, [customerDetails]);

  const selectedSectionChange = (e) => {
    if (customerDetails?.Data?.is_karza_response_recieved !== "False") {
      setSelectedSection("Upload Salary slip");
    }
  };

  useEffect(() => {
    // moengage.add_unique_user_id(customerDetails.Data.uuid);

    isStageLogin(    
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
    setTimeout(function() {
      moengage.track_event("Disbursement_Reverify", {
        Application_under_review: "YES",
      });
    }, 2000);
    if (customerDetails?.Data?.is_karza_response_recieved === "False") {
      setSelectedSection("Upload Salary slip");
    }
  }, []);

  const uploadFile1 = useRef(null);
  const uploadFile2 = useRef(null);
  const uploadFile3 = useRef(null);

  const [uploadedFile1, setUploadedFile1] = useState(false);
  const [prevUploadedFile1, setPrevUploadedFile1] = useState(false);
  const [uploadedFile2, setUploadedFile2] = useState(false);
  const [prevUploadedFile2, setPrevUploadedFile2] = useState(false);
  const [uploadedFile3, setUploadedFile3] = useState(false);
  const [prevUploadedFile3, setPrevUploadedFile3] = useState(false);
  const [file1Name, setFile1Name] = useState("");
  const [file2Name, setFile2Name] = useState("");
  const [file3Name, setFile3Name] = useState("");
  const [a8Modal, seta8Modal] = useState(false);

  useEffect(() => {
    if (
      customerDetails?.Data?.salary1 !== "" &&
      customerDetails?.Data?.salary1 !== null &&
      customerDetails?.Data?.salary1 !== "None" &&
      customerDetails?.Data?.salary1 !== "0" &&
      customerDetails?.Data?.salary1 !== undefined
    ) {
      // console.log(customerDetails?.Data?.salary1);
      setPrevUploadedFile1(true);
      setFile1Name(customerDetails?.Data?.salary1);
    }
    // if (
    //   customerDetails?.Data?.salary2 !== "" &&
    //   customerDetails?.Data?.salary2 !== null &&
    //   customerDetails?.Data?.salary2 !== "None" &&
    //   customerDetails?.Data?.salary2 !== "0" &&
    //   customerDetails?.Data?.salary2 !== undefined
    // ) {
    //   setPrevUploadedFile2(true);
    //   setFile2Name(customerDetails?.Data?.salary2);
    // }
    // if (
    //   customerDetails?.Data?.salary3 !== null &&
    //   customerDetails?.Data?.salary3 !== "" &&
    //   customerDetails?.Data?.salary3 !== "None" &&
    //   customerDetails?.Data?.salary3 !== "0" &&
    //   customerDetails?.Data?.salary3 !== undefined
    // ) {
    //   setPrevUploadedFile3(true);
    //   setFile3Name(customerDetails?.Data?.salary3);
    // }
  }, []);

  const UploadFileAPI = async (key, file) => {
    try {
      const docName = key;
      const docExt = file.name.split(".").pop();
      const docBase64 = await convertToBase64(file);
      var payload = {
        application_form_no: sessionStorage.getItem("application_form_no"),
        document_name: docName,
        document_base64: docBase64,
        document_extension: docExt,
        uploaded_doc_name: file.name.split(".").slice(0, -1).join("."),
      };
      const formData = new FormData();
      // console.log(file.name.split(".").slice(0, -1).join("."));
      // console.log(payload);
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + source + UPLOAD_DOCS_NSTP,
        formData
      );
      console.log("Response: ", response);
      if (response.response.Success) {
        if (key === "salary1") {
          setFile1Name(file.name);
          setUploadedFile1(true);
        }
        // if (key === "salary2") {
        //   setFile2Name(file.name);
        //   setUploadedFile2(true);
        // }
        // if (key === "salary3") {
        //   setFile3Name(file.name);
        //   setUploadedFile3(true);
        // }
      }
    } catch (error) {
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
    }
  };

  const MoveToNSTP = async () => {
    try {
      var payload = {
        application_form_no: sessionStorage.getItem("application_form_no"),
      };
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest("/" + source + MOVE_TO_NSTP, formData);
      console.log("Response: ", response);

      if (response.response.Success) {
        seta8Modal(true);
      }
    } catch (error) {
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
    }
  };

  const handleFileUploadSubmit1 = async () => {
    // console.log(uploadFile1.current);
    const file1 = uploadFile1.current.files[0];
    // console.log(file1);

    if (!file1?.name) {
      setErrorMessageFile1("Please upload a document");
    } else {
      setErrorMessageFile1("");
    }

    if (file1) {
      try {
        // const base64File1 = await convertToBase64(file1);
        // console.log(base64File1);
        if (file1.size < 5e6) {
          await UploadFileAPI("salary1", file1);
        } else {
          setErrorMessageFile1("Please upload a file smaller than 5 MB");
        }
      } catch (error) {
        console.error("Error converting file to base64:", error);
      }
    }
  };

  const handleFileUploadSubmit2 = async () => {
    const file2 = uploadFile2.current.files[0];

    if (!file2?.name) {
      setErrorMessageFile2("Please upload a document");
    } else {
      setErrorMessageFile2("");
    }

    if (file2) {
      try {
        // const base64File2 = await convertToBase64(file2);
        // console.log(base64File2);
        if (file2.size < 5e6) {
          await UploadFileAPI("salary2", file2);
        } else {
          setErrorMessageFile2("Please upload a file smaller than 5 MB");
        }
      } catch (error) {
        console.error("Error converting file to base64:", error);
      }
    }
  };

  const handleFileUploadSubmit3 = async () => {
    const file3 = uploadFile3.current.files[0];

    if (!file3?.name) {
      setErrorMessageFile3("Please upload a document");
    } else {
      setErrorMessageFile3("");
    }

    if (file3) {
      try {
        // const base64File3 = await convertToBase64(file3);
        // console.log(base64File3);
        if (file3.size < 5e6) {
          await UploadFileAPI("salary3", file3);
        } else {
          setErrorMessageFile3("Please upload a file smaller than 5 MB");
        }
      } catch (error) {
        console.error("Error converting file to base64:", error);
      }
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  useEffect(() => {
    var otpString = otpDigits.join("");
    if (isValidOTP(otpString)) {
      setIsOtpValid(true);
      setOtp(otpString);
    } else {
      setIsOtpValid(false);
    }
  }, [otpDigits]);

  const resetOTP = async () => {
    const newOtpDigits = [...otpDigits];
    for (let i = 0; i < 6; i++) {
      newOtpDigits[i] = "";
    }
    setOtpDigits(newOtpDigits);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          SetEnableResendOtp(true);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  return (
    <>
      <ProgressBar showProgress={true} currentStep={6} />
      <A8MovedModal
        isOpen={a8Modal}
        onClose={() => {
          // setA8Modal(false);
          // var route = getRouteFromLoanStageService({
          //   source: customerDetails.source,
          //   stage: "rejected",
          // });
          // console.log("route: ", route);
          // navigate(`${route}`, {
          //   replace: true,
          // });
        }}
      />
      <CheckInternetModal
        isOpen={internetCheck}
        onClose={() => {
          setInternetCheck(false);
          setShowShimmer(false);
        }}
      />
      <MaxOtpRetryModal
        isOpen={showMaxRetryModal}
        onClose={() => {
          setShowMaxRetryModal(false);
          setIsOtpSent(true);
          SetEnableResendOtp(false);
          setResendOtp(false);
          setMinutes(15);
          setSeconds(1);
          resetOTP();
        }}
      />
      <OtpExpiredModal
        isOpen={showOtpExpiredModal}
        onClose={() => {
          setShowOtpExpiredModal(false);
          setIsOtpSent(true);
          resetOTP();
        }}
      />
      <ResendOtpEmailModal
        isOpen={resendOtp}
        onClose={() => {
          SetEnableResendOtp(false);
          setResendOtp(false);
          setMinutes(2);
          setSeconds(59);
          resetOTP();
        }}
      />
      <IncorrectOtpModal
        isOpen={isOtpwrong}
        onClose={() => {
          SetIsOtpWrong(false);
          setIsOtpSent(true);
          SetEnableResendOtp(false);
          setResendOtp(false);
          setSeconds(10);
          resetOTP();
        }}
      />
      <DisbursementReverifyWrapper className="first-child">
        <ShimmerPlaceholder
          height="2.5em"
          marginTop="1em"
          width="12em"
          visible={showShimmer}
        />
        <div className="pageTitle">
          <Title
            text={`Employment Verification`}
            visible={!showShimmer}
            clickable={false}
            icon={
              <>
                <img
                  src={Icon_Agreement_form}
                  alt="titleIcon.svg"
                  height="20"
                  width="20"
                />
              </>
            }
          />
        </div>
        <div
          style={{
            color: "#6B6B6B",
            fontSize: "15.5px",
            display: "flex",
            paddingLeft: "2em",
            paddingRight:"0em",
            paddingTop: "0.5em",
            whiteSpace: "pre-line"
          }}
        >
          {"Your employment verification is pending. \n Please verify within 48 hours to avoid application cancellation. Funds will released upon positive verification only."}
        </div>
        {/* <div
          style={{
            display: showShimmer ? "none" : "flex",
          }}
          className={"additional-confirm"}
        >
          <div style={{ display: "contents" }}>
            <input
              type="radio"
              id="Verify using OTP"
              name="confirm-additional-detail"
              checked={selectedSection === "Verify using OTP"}
              value={"Verify using OTP"}
              onChange={selectedSectionChange}
            />
            <label for="Verify using OTP">Verify using OTP</label>
          </div>
          <div style={{ display: "contents" }}>
            <input
              type="radio"
              id="Upload Salary slip"
              name="confirm-additional-detail"
              checked={selectedSection === "Upload Salary slip"}
              value={"Upload Salary slip"}
              onChange={selectedSectionChange}
            />
            <label for="Upload Salary slip">Upload Salary slip</label>
          </div>
        </div> */}
        {selectedSection === "Verify using OTP" ? (
          <>
            <div className="label-text">
              Below is your official Email ID , Please verify with OTP
            </div>
            <div style={{ padding: "2em" }}>
              <FloatingInput
                value={customerDetails?.Data?.org_email_id}
                visible={!showShimmer}
                // disabled={customerDetails?.source === "upsell"}
                disabled={true}
                type={"text"}
                label={"Official Email ID"}
              />
            </div>
            {isOtpSent ? (
              <>
                <div className="heading2">Enter OTP</div>
                <div className="otp-box">
                  <div>
                    <OTPInput
                      length={6}
                      otpDigits={otpDigits}
                      setOtpDigits={setOtpDigits}
                    />
                  </div>
                </div>
                <div className="resnd-otp-row">
                  <div className="resend-otp">
                    {enableResendOtp ? (
                      <></>
                    ) : (
                      <>
                        <img className="timer-img" src={timer} />
                      </>
                    )}
                    <button
                      disabled={!enableResendOtp}
                      style={{
                        border: "None",
                        backgroundColor: "transparent",
                        color: enableResendOtp ? "#3C94FC" : "grey",
                        marginRight: "5px",
                      }}
                      onClick={async () => {
                        resendOTP();
                        // console.log("resend OTP clicked");
                      }}
                    >
                      Re-send OTP
                    </button>
                  </div>
                  {enableResendOtp ? (
                    <></>
                  ) : (
                    <>
                      <div>
                        in {minutes < 10 ? `0${minutes}` : minutes}:
                        {seconds < 10 ? `0${seconds}` : seconds}
                        {/* in 00:
                            {seconds < 10 ? `0${seconds}` : seconds} */}
                      </div>
                    </>
                  )}
                </div>
                <Button
                  id="VerifyOTP"
                  className="Btn VerifyOTP"
                  disabled={!isOtpValid}
                  mobile={isMobile}
                  onClick={() => {
                    VerifyOTPOnEmail();
                  }}
                  text={"Verify"}
                />
              </>
            ) : (
              <>
                {showShimmer ? (
                  <></>
                ) : (
                  <>
                    <Button
                      id="GetOTP"
                      className="Btn GetOTP"
                      disabled={false}
                      mobile={isMobile}
                      onClick={() => {
                        resendOTP();
                      }}
                      text={"Get OTP"}
                    />
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <div style={{ padding: "2em 2em 1em 2em" }}>
              <DocumentUploadInputWrapper>
                <div className="main-container-doc-input" onClick={() => {}}>
                  <div>
                    <span>
                      <img src={Pdf_icon} alt="icon" />
                    </span>
                    <span>
                      <p>Salary slip 1</p>
                    </span>
                  </div>
                  <div
                    style={{
                      display:
                        prevUploadedFile1 || uploadedFile1 ? "flex" : "none",
                    }}
                  >
                    <p> &#9989;</p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <input
                      type="file"
                      ref={uploadFile1}
                      accept={".pdf, .jpeg, .jpg, .png"}
                      style={{ display: "block" }}
                    />
                    <small style={{ color: "red", fontSize: "1.1em" }}>
                      {errorMessagefile1}
                    </small>
                  </div>
                  <Button
                    text={"Upload"}
                    onClick={handleFileUploadSubmit1}
                    style={{
                      // width: "40%",
                      height: "35px",
                      fontSize: "1.1em",
                      marginTop: "5px",
                    }}
                  />
                </div>
                <div className="tickMark">
                  <div>{file1Name}</div>
                </div>
              </DocumentUploadInputWrapper>
              {/* <DocumentUploadInputWrapper>
                <div className="main-container-doc-input" onClick={() => {}}>
                  <div>
                    <span>
                      <img src={Pdf_icon} alt="icon" />
                    </span>
                    <span>
                      <p>Salary slip 2</p>
                    </span>
                  </div>
                  <div
                    style={{
                      display:
                        prevUploadedFile2 || uploadedFile2 ? "flex" : "none",
                    }}
                  >
                    <p> &#9989;</p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <input
                      type="file"
                      ref={uploadFile2}
                      accept={".pdf, .jpeg, .jpg, .png"}
                      style={{ display: "block" }}
                    />
                    <small style={{ color: "red", fontSize: "1.1em" }}>
                      {errorMessagefile2}
                    </small>
                  </div>
                  <Button
                    text={"Upload"}
                    onClick={handleFileUploadSubmit2}
                    style={{
                      // width: "40%",
                      height: "35px",
                      fontSize: "1.1em",
                      marginTop: "5px",
                    }}
                  />
                </div>
                <div className="tickMark">
                  <div>{file2Name}</div>
                </div>
              </DocumentUploadInputWrapper>
              <DocumentUploadInputWrapper>
                <div className="main-container-doc-input" onClick={() => {}}>
                  <div>
                    <span>
                      <img src={Pdf_icon} alt="icon" />
                    </span>
                    <span>
                      <p>Salary slip 3</p>
                    </span>
                  </div>
                  <div
                    style={{
                      display:
                        prevUploadedFile3 || uploadedFile3 ? "flex" : "none",
                    }}
                  >
                    <p> &#9989;</p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <input
                      type="file"
                      ref={uploadFile3}
                      accept={".pdf, .jpeg, .jpg, .png"}
                      style={{ display: "block" }}
                    />
                    <small style={{ color: "red", fontSize: "1.1em" }}>
                      {errorMessagefile3}
                    </small>
                  </div>
                  <Button
                    text={"Upload"}
                    onClick={handleFileUploadSubmit3}
                    style={{
                      // width: "40%",
                      height: "35px",
                      fontSize: "1.1em",
                      marginTop: "5px",
                    }}
                  />
                </div>
                <div className="tickMark">
                  <div>{file3Name}</div>
                </div>
              </DocumentUploadInputWrapper> */}
              <div
                style={{
                  color: "#6B6B6B",
                  fontSize: "18px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Do not upload password protected documents
              </div>
            </div>
            <Button
              id="ProceedBtn"
              className="Btn"
              disabled={
                // !(file1Name !== "" && file2Name !== "" && file3Name !== "")
                !(file1Name !== "")
              }
              text={"Proceed"}
              onClick={MoveToNSTP}
            />
          </>
        )}
      </DisbursementReverifyWrapper>
    </>
  );
};

export default DisbursementReverify;
